/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgGraphBuilderBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.40933 6.93311C7.099 7.08977 7.82266 6.96603 8.4211 6.58913C9.01955 6.21223 9.44376 5.61303 9.60041 4.92335C9.75706 4.23367 9.63333 3.51002 9.25642 2.91157C8.87952 2.31313 8.28032 1.88892 7.59065 1.73226C6.90098 1.57561 6.17732 1.69935 5.57888 2.07625C4.98043 2.45315 4.55622 3.05235 4.39957 3.74203C4.24292 4.4317 4.36665 5.15536 4.74356 5.75381C5.12046 6.35225 5.71966 6.77646 6.40933 6.93311ZM6.40933 6.93311L5.02352 13.0902M17.3333 12.9993C17.0025 13.2496 16.6148 13.4217 16.199 13.497M15.6667 8.33268C16.0744 8.33268 16.4725 8.42606 16.8324 8.60097M18.1387 9.99935C18.2661 10.3141 18.3333 10.6533 18.3333 10.9993M13.9036 12.9993C13.6643 12.76 13.4751 12.4798 13.3429 12.1751M13.1946 9.99935C13.3275 9.67093 13.5257 9.3691 13.7811 9.11373M5.02352 13.0902C4.34037 12.9072 3.6125 13.003 3.00001 13.3566C2.38752 13.7102 1.94059 14.2927 1.75754 14.9758C1.5745 15.659 1.67032 16.3869 2.02394 16.9993C2.37756 17.6118 2.96001 18.0588 3.64315 18.2418C4.3263 18.4249 5.05417 18.329 5.66666 17.9754C6.27915 17.6218 6.72608 17.0393 6.90913 16.3562C7.09217 15.6731 6.99635 14.9452 6.64273 14.3327M5.02352 13.0902C5.70666 13.2733 6.28911 13.7202 6.64273 14.3327M6.64273 14.3327L8.66665 13.666M9.66665 4.99936L10.5 5.83268M11.8333 7.24935L12.5 7.91602M10.3333 13.0902L11.6666 12.666"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgGraphBuilder = wrapIcon(SvgGraphBuilderBase);
export default SvgGraphBuilder;
